import React, { useState } from "react";
import { questions } from './Api';
import Myaccordian from "./Myaccordian";
import './accordian.css';


const Accordiann = () => {
    const [data, setData] = useState(questions);
    return (
        <>
        <section className="main-div">
                <h1>React Interview Questions </h1>
            {
                data.map((curElem) => {
                    const {id} = curElem;
                    return (<Myaccordian key={id} {...curElem} />)
                   
                })
            }
            </section>
        </>
    )

}

export default Accordiann;